export const dlProductPhotoUploadedEvent = (type, layout, fileInfo) => {
    window.dataLayer.push({
        event: 'Upload Photo',
        custom: {
            type,
            layout,
            fileInfo
        }
    });
};
